// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2YnmP","requiredAsterisk":"Info_requiredAsterisk__3gu1h"};